import { motion } from "framer-motion";

export const KineticLines = ({ lines, className = "", lineClassName = "" }) => (
    <span className={className}>
        {lines.map((line, i) => (
            <span key={i} className="block overflow-hidden pb-1">
                <motion.span
                    className={`block ${lineClassName}`}
                    initial={{ y: "110%" }}
                    animate={{ y: 0 }}
                    transition={{ duration: 0.9, delay: 0.2 + i * 0.13, ease: [0.22, 1, 0.36, 1] }}
                >
                    {line}
                </motion.span>
            </span>
        ))}
    </span>
);
